// source: nockchain/common/v1/primitives.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.nockchain.common.v1.Acknowledged', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Base58Hash', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Base58Pubkey', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Belt', null, global);
goog.exportSymbol('proto.nockchain.common.v1.BlockHeight', null, global);
goog.exportSymbol('proto.nockchain.common.v1.BlockHeightDelta', null, global);
goog.exportSymbol('proto.nockchain.common.v1.CheetahPoint', null, global);
goog.exportSymbol('proto.nockchain.common.v1.EightBelt', null, global);
goog.exportSymbol('proto.nockchain.common.v1.ErrorCode', null, global);
goog.exportSymbol('proto.nockchain.common.v1.ErrorStatus', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Hash', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Nicks', null, global);
goog.exportSymbol('proto.nockchain.common.v1.NoteVersion', null, global);
goog.exportSymbol('proto.nockchain.common.v1.SchnorrPubkey', null, global);
goog.exportSymbol('proto.nockchain.common.v1.SixBelt', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Wire', null, global);
goog.exportSymbol('proto.nockchain.common.v1.WireTag', null, global);
goog.exportSymbol('proto.nockchain.common.v1.WireTag.ValueCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.ErrorStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.ErrorStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.ErrorStatus.displayName = 'proto.nockchain.common.v1.ErrorStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Acknowledged = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Acknowledged, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Acknowledged.displayName = 'proto.nockchain.common.v1.Acknowledged';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Wire = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v1.Wire.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v1.Wire, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Wire.displayName = 'proto.nockchain.common.v1.Wire';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.WireTag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.common.v1.WireTag.oneofGroups_);
};
goog.inherits(proto.nockchain.common.v1.WireTag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.WireTag.displayName = 'proto.nockchain.common.v1.WireTag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.NoteVersion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.NoteVersion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.NoteVersion.displayName = 'proto.nockchain.common.v1.NoteVersion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.BlockHeight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.BlockHeight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.BlockHeight.displayName = 'proto.nockchain.common.v1.BlockHeight';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.BlockHeightDelta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.BlockHeightDelta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.BlockHeightDelta.displayName = 'proto.nockchain.common.v1.BlockHeightDelta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Nicks = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Nicks, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Nicks.displayName = 'proto.nockchain.common.v1.Nicks';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.EightBelt = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.EightBelt, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.EightBelt.displayName = 'proto.nockchain.common.v1.EightBelt';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Hash = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Hash, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Hash.displayName = 'proto.nockchain.common.v1.Hash';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Base58Hash = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Base58Hash, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Base58Hash.displayName = 'proto.nockchain.common.v1.Base58Hash';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Base58Pubkey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Base58Pubkey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Base58Pubkey.displayName = 'proto.nockchain.common.v1.Base58Pubkey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.SchnorrPubkey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.SchnorrPubkey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.SchnorrPubkey.displayName = 'proto.nockchain.common.v1.SchnorrPubkey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.CheetahPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.CheetahPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.CheetahPoint.displayName = 'proto.nockchain.common.v1.CheetahPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.SixBelt = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.SixBelt, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.SixBelt.displayName = 'proto.nockchain.common.v1.SixBelt';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Belt = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Belt, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Belt.displayName = 'proto.nockchain.common.v1.Belt';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.ErrorStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.ErrorStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.ErrorStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.ErrorStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
code: jspb.Message.getFieldWithDefault(msg, 1, 0),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
details: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.common.v1.ErrorStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.ErrorStatus;
  return proto.nockchain.common.v1.ErrorStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.ErrorStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.ErrorStatus}
 */
proto.nockchain.common.v1.ErrorStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.nockchain.common.v1.ErrorCode} */ (reader.readEnum());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.ErrorStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.ErrorStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.ErrorStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.ErrorStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional ErrorCode code = 1;
 * @return {!proto.nockchain.common.v1.ErrorCode}
 */
proto.nockchain.common.v1.ErrorStatus.prototype.getCode = function() {
  return /** @type {!proto.nockchain.common.v1.ErrorCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.nockchain.common.v1.ErrorCode} value
 * @return {!proto.nockchain.common.v1.ErrorStatus} returns this
 */
proto.nockchain.common.v1.ErrorStatus.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.nockchain.common.v1.ErrorStatus.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.common.v1.ErrorStatus} returns this
 */
proto.nockchain.common.v1.ErrorStatus.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string details = 3;
 * @return {string}
 */
proto.nockchain.common.v1.ErrorStatus.prototype.getDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.common.v1.ErrorStatus} returns this
 */
proto.nockchain.common.v1.ErrorStatus.prototype.setDetails = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.nockchain.common.v1.ErrorStatus} returns this
 */
proto.nockchain.common.v1.ErrorStatus.prototype.clearDetails = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.ErrorStatus.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Acknowledged.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Acknowledged.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Acknowledged} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Acknowledged.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Acknowledged}
 */
proto.nockchain.common.v1.Acknowledged.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Acknowledged;
  return proto.nockchain.common.v1.Acknowledged.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Acknowledged} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Acknowledged}
 */
proto.nockchain.common.v1.Acknowledged.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Acknowledged.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Acknowledged.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Acknowledged} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Acknowledged.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v1.Wire.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Wire.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Wire.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Wire} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Wire.toObject = function(includeInstance, msg) {
  var f, obj = {
source: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: jspb.Message.getFieldWithDefault(msg, 2, 0),
tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    proto.nockchain.common.v1.WireTag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Wire}
 */
proto.nockchain.common.v1.Wire.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Wire;
  return proto.nockchain.common.v1.Wire.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Wire} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Wire}
 */
proto.nockchain.common.v1.Wire.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVersion(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v1.WireTag;
      reader.readMessage(value,proto.nockchain.common.v1.WireTag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Wire.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Wire.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Wire} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Wire.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.nockchain.common.v1.WireTag.serializeBinaryToWriter
    );
  }
};


/**
 * optional string source = 1;
 * @return {string}
 */
proto.nockchain.common.v1.Wire.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.common.v1.Wire} returns this
 */
proto.nockchain.common.v1.Wire.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 version = 2;
 * @return {number}
 */
proto.nockchain.common.v1.Wire.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v1.Wire} returns this
 */
proto.nockchain.common.v1.Wire.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated WireTag tags = 3;
 * @return {!Array<!proto.nockchain.common.v1.WireTag>}
 */
proto.nockchain.common.v1.Wire.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.WireTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v1.WireTag, 3));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.WireTag>} value
 * @return {!proto.nockchain.common.v1.Wire} returns this
*/
proto.nockchain.common.v1.Wire.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.nockchain.common.v1.WireTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.WireTag}
 */
proto.nockchain.common.v1.Wire.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.nockchain.common.v1.WireTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v1.Wire} returns this
 */
proto.nockchain.common.v1.Wire.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.common.v1.WireTag.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.nockchain.common.v1.WireTag.ValueCase = {
  VALUE_NOT_SET: 0,
  TEXT: 1,
  NUMBER: 2
};

/**
 * @return {proto.nockchain.common.v1.WireTag.ValueCase}
 */
proto.nockchain.common.v1.WireTag.prototype.getValueCase = function() {
  return /** @type {proto.nockchain.common.v1.WireTag.ValueCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.common.v1.WireTag.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.WireTag.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.WireTag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.WireTag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.WireTag.toObject = function(includeInstance, msg) {
  var f, obj = {
text: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
number: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.WireTag}
 */
proto.nockchain.common.v1.WireTag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.WireTag;
  return proto.nockchain.common.v1.WireTag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.WireTag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.WireTag}
 */
proto.nockchain.common.v1.WireTag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.WireTag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.WireTag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.WireTag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.WireTag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string text = 1;
 * @return {string}
 */
proto.nockchain.common.v1.WireTag.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.common.v1.WireTag} returns this
 */
proto.nockchain.common.v1.WireTag.prototype.setText = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.nockchain.common.v1.WireTag.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.nockchain.common.v1.WireTag} returns this
 */
proto.nockchain.common.v1.WireTag.prototype.clearText = function() {
  return jspb.Message.setOneofField(this, 1, proto.nockchain.common.v1.WireTag.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.WireTag.prototype.hasText = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 number = 2;
 * @return {number}
 */
proto.nockchain.common.v1.WireTag.prototype.getNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v1.WireTag} returns this
 */
proto.nockchain.common.v1.WireTag.prototype.setNumber = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.nockchain.common.v1.WireTag.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.nockchain.common.v1.WireTag} returns this
 */
proto.nockchain.common.v1.WireTag.prototype.clearNumber = function() {
  return jspb.Message.setOneofField(this, 2, proto.nockchain.common.v1.WireTag.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.WireTag.prototype.hasNumber = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.NoteVersion.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.NoteVersion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.NoteVersion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.NoteVersion.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.NoteVersion}
 */
proto.nockchain.common.v1.NoteVersion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.NoteVersion;
  return proto.nockchain.common.v1.NoteVersion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.NoteVersion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.NoteVersion}
 */
proto.nockchain.common.v1.NoteVersion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.NoteVersion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.NoteVersion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.NoteVersion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.NoteVersion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 value = 1;
 * @return {number}
 */
proto.nockchain.common.v1.NoteVersion.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v1.NoteVersion} returns this
 */
proto.nockchain.common.v1.NoteVersion.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.BlockHeight.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.BlockHeight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.BlockHeight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.BlockHeight.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.BlockHeight}
 */
proto.nockchain.common.v1.BlockHeight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.BlockHeight;
  return proto.nockchain.common.v1.BlockHeight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.BlockHeight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.BlockHeight}
 */
proto.nockchain.common.v1.BlockHeight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.BlockHeight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.BlockHeight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.BlockHeight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.BlockHeight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 value = 1;
 * @return {number}
 */
proto.nockchain.common.v1.BlockHeight.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v1.BlockHeight} returns this
 */
proto.nockchain.common.v1.BlockHeight.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.BlockHeightDelta.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.BlockHeightDelta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.BlockHeightDelta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.BlockHeightDelta.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.BlockHeightDelta}
 */
proto.nockchain.common.v1.BlockHeightDelta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.BlockHeightDelta;
  return proto.nockchain.common.v1.BlockHeightDelta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.BlockHeightDelta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.BlockHeightDelta}
 */
proto.nockchain.common.v1.BlockHeightDelta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.BlockHeightDelta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.BlockHeightDelta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.BlockHeightDelta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.BlockHeightDelta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 value = 1;
 * @return {number}
 */
proto.nockchain.common.v1.BlockHeightDelta.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v1.BlockHeightDelta} returns this
 */
proto.nockchain.common.v1.BlockHeightDelta.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Nicks.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Nicks.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Nicks} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Nicks.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v1.Nicks.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Nicks;
  return proto.nockchain.common.v1.Nicks.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Nicks} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v1.Nicks.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Nicks.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Nicks.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Nicks} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Nicks.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 value = 1;
 * @return {number}
 */
proto.nockchain.common.v1.Nicks.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v1.Nicks} returns this
 */
proto.nockchain.common.v1.Nicks.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.EightBelt.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.EightBelt.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.EightBelt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.EightBelt.toObject = function(includeInstance, msg) {
  var f, obj = {
belt1: (f = msg.getBelt1()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt2: (f = msg.getBelt2()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt3: (f = msg.getBelt3()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt4: (f = msg.getBelt4()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt5: (f = msg.getBelt5()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt6: (f = msg.getBelt6()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt7: (f = msg.getBelt7()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt8: (f = msg.getBelt8()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.EightBelt}
 */
proto.nockchain.common.v1.EightBelt.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.EightBelt;
  return proto.nockchain.common.v1.EightBelt.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.EightBelt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.EightBelt}
 */
proto.nockchain.common.v1.EightBelt.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt1(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt2(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt3(value);
      break;
    case 4:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt4(value);
      break;
    case 5:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt5(value);
      break;
    case 6:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt6(value);
      break;
    case 7:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt7(value);
      break;
    case 8:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt8(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.EightBelt.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.EightBelt.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.EightBelt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.EightBelt.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBelt1();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt2();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt3();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt4();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt5();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt6();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt7();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt8();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
};


/**
 * optional Belt belt_1 = 1;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.EightBelt.prototype.getBelt1 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
*/
proto.nockchain.common.v1.EightBelt.prototype.setBelt1 = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
 */
proto.nockchain.common.v1.EightBelt.prototype.clearBelt1 = function() {
  return this.setBelt1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.EightBelt.prototype.hasBelt1 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Belt belt_2 = 2;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.EightBelt.prototype.getBelt2 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
*/
proto.nockchain.common.v1.EightBelt.prototype.setBelt2 = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
 */
proto.nockchain.common.v1.EightBelt.prototype.clearBelt2 = function() {
  return this.setBelt2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.EightBelt.prototype.hasBelt2 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Belt belt_3 = 3;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.EightBelt.prototype.getBelt3 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
*/
proto.nockchain.common.v1.EightBelt.prototype.setBelt3 = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
 */
proto.nockchain.common.v1.EightBelt.prototype.clearBelt3 = function() {
  return this.setBelt3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.EightBelt.prototype.hasBelt3 = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Belt belt_4 = 4;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.EightBelt.prototype.getBelt4 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 4));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
*/
proto.nockchain.common.v1.EightBelt.prototype.setBelt4 = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
 */
proto.nockchain.common.v1.EightBelt.prototype.clearBelt4 = function() {
  return this.setBelt4(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.EightBelt.prototype.hasBelt4 = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Belt belt_5 = 5;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.EightBelt.prototype.getBelt5 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 5));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
*/
proto.nockchain.common.v1.EightBelt.prototype.setBelt5 = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
 */
proto.nockchain.common.v1.EightBelt.prototype.clearBelt5 = function() {
  return this.setBelt5(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.EightBelt.prototype.hasBelt5 = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Belt belt_6 = 6;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.EightBelt.prototype.getBelt6 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 6));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
*/
proto.nockchain.common.v1.EightBelt.prototype.setBelt6 = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
 */
proto.nockchain.common.v1.EightBelt.prototype.clearBelt6 = function() {
  return this.setBelt6(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.EightBelt.prototype.hasBelt6 = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Belt belt_7 = 7;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.EightBelt.prototype.getBelt7 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 7));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
*/
proto.nockchain.common.v1.EightBelt.prototype.setBelt7 = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
 */
proto.nockchain.common.v1.EightBelt.prototype.clearBelt7 = function() {
  return this.setBelt7(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.EightBelt.prototype.hasBelt7 = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Belt belt_8 = 8;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.EightBelt.prototype.getBelt8 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 8));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
*/
proto.nockchain.common.v1.EightBelt.prototype.setBelt8 = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.EightBelt} returns this
 */
proto.nockchain.common.v1.EightBelt.prototype.clearBelt8 = function() {
  return this.setBelt8(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.EightBelt.prototype.hasBelt8 = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Hash.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Hash.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Hash} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Hash.toObject = function(includeInstance, msg) {
  var f, obj = {
belt1: (f = msg.getBelt1()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt2: (f = msg.getBelt2()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt3: (f = msg.getBelt3()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt4: (f = msg.getBelt4()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt5: (f = msg.getBelt5()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v1.Hash.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Hash;
  return proto.nockchain.common.v1.Hash.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Hash} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v1.Hash.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt1(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt2(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt3(value);
      break;
    case 4:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt4(value);
      break;
    case 5:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt5(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Hash.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Hash.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Hash} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Hash.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBelt1();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt2();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt3();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt4();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt5();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
};


/**
 * optional Belt belt_1 = 1;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.Hash.prototype.getBelt1 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.Hash} returns this
*/
proto.nockchain.common.v1.Hash.prototype.setBelt1 = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Hash} returns this
 */
proto.nockchain.common.v1.Hash.prototype.clearBelt1 = function() {
  return this.setBelt1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Hash.prototype.hasBelt1 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Belt belt_2 = 2;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.Hash.prototype.getBelt2 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.Hash} returns this
*/
proto.nockchain.common.v1.Hash.prototype.setBelt2 = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Hash} returns this
 */
proto.nockchain.common.v1.Hash.prototype.clearBelt2 = function() {
  return this.setBelt2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Hash.prototype.hasBelt2 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Belt belt_3 = 3;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.Hash.prototype.getBelt3 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.Hash} returns this
*/
proto.nockchain.common.v1.Hash.prototype.setBelt3 = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Hash} returns this
 */
proto.nockchain.common.v1.Hash.prototype.clearBelt3 = function() {
  return this.setBelt3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Hash.prototype.hasBelt3 = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Belt belt_4 = 4;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.Hash.prototype.getBelt4 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 4));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.Hash} returns this
*/
proto.nockchain.common.v1.Hash.prototype.setBelt4 = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Hash} returns this
 */
proto.nockchain.common.v1.Hash.prototype.clearBelt4 = function() {
  return this.setBelt4(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Hash.prototype.hasBelt4 = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Belt belt_5 = 5;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.Hash.prototype.getBelt5 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 5));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.Hash} returns this
*/
proto.nockchain.common.v1.Hash.prototype.setBelt5 = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Hash} returns this
 */
proto.nockchain.common.v1.Hash.prototype.clearBelt5 = function() {
  return this.setBelt5(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Hash.prototype.hasBelt5 = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Base58Hash.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Base58Hash.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Base58Hash} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Base58Hash.toObject = function(includeInstance, msg) {
  var f, obj = {
hash: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.common.v1.Base58Hash.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Base58Hash;
  return proto.nockchain.common.v1.Base58Hash.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Base58Hash} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Base58Hash}
 */
proto.nockchain.common.v1.Base58Hash.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Base58Hash.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Base58Hash.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Base58Hash} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Base58Hash.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string hash = 1;
 * @return {string}
 */
proto.nockchain.common.v1.Base58Hash.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.common.v1.Base58Hash} returns this
 */
proto.nockchain.common.v1.Base58Hash.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Base58Pubkey.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Base58Pubkey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Base58Pubkey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Base58Pubkey.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Base58Pubkey}
 */
proto.nockchain.common.v1.Base58Pubkey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Base58Pubkey;
  return proto.nockchain.common.v1.Base58Pubkey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Base58Pubkey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Base58Pubkey}
 */
proto.nockchain.common.v1.Base58Pubkey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Base58Pubkey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Base58Pubkey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Base58Pubkey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Base58Pubkey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.nockchain.common.v1.Base58Pubkey.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.nockchain.common.v1.Base58Pubkey} returns this
 */
proto.nockchain.common.v1.Base58Pubkey.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.SchnorrPubkey.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.SchnorrPubkey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.SchnorrPubkey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.SchnorrPubkey.toObject = function(includeInstance, msg) {
  var f, obj = {
value: (f = msg.getValue()) && proto.nockchain.common.v1.CheetahPoint.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.SchnorrPubkey}
 */
proto.nockchain.common.v1.SchnorrPubkey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.SchnorrPubkey;
  return proto.nockchain.common.v1.SchnorrPubkey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.SchnorrPubkey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.SchnorrPubkey}
 */
proto.nockchain.common.v1.SchnorrPubkey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.CheetahPoint;
      reader.readMessage(value,proto.nockchain.common.v1.CheetahPoint.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.SchnorrPubkey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.SchnorrPubkey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.SchnorrPubkey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.SchnorrPubkey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.CheetahPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional CheetahPoint value = 1;
 * @return {?proto.nockchain.common.v1.CheetahPoint}
 */
proto.nockchain.common.v1.SchnorrPubkey.prototype.getValue = function() {
  return /** @type{?proto.nockchain.common.v1.CheetahPoint} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.CheetahPoint, 1));
};


/**
 * @param {?proto.nockchain.common.v1.CheetahPoint|undefined} value
 * @return {!proto.nockchain.common.v1.SchnorrPubkey} returns this
*/
proto.nockchain.common.v1.SchnorrPubkey.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SchnorrPubkey} returns this
 */
proto.nockchain.common.v1.SchnorrPubkey.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SchnorrPubkey.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.CheetahPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.CheetahPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.CheetahPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.CheetahPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
x: (f = msg.getX()) && proto.nockchain.common.v1.SixBelt.toObject(includeInstance, f),
y: (f = msg.getY()) && proto.nockchain.common.v1.SixBelt.toObject(includeInstance, f),
inf: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.CheetahPoint}
 */
proto.nockchain.common.v1.CheetahPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.CheetahPoint;
  return proto.nockchain.common.v1.CheetahPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.CheetahPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.CheetahPoint}
 */
proto.nockchain.common.v1.CheetahPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.SixBelt;
      reader.readMessage(value,proto.nockchain.common.v1.SixBelt.deserializeBinaryFromReader);
      msg.setX(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.SixBelt;
      reader.readMessage(value,proto.nockchain.common.v1.SixBelt.deserializeBinaryFromReader);
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInf(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.CheetahPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.CheetahPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.CheetahPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.CheetahPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.SixBelt.serializeBinaryToWriter
    );
  }
  f = message.getY();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.SixBelt.serializeBinaryToWriter
    );
  }
  f = message.getInf();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional SixBelt x = 1;
 * @return {?proto.nockchain.common.v1.SixBelt}
 */
proto.nockchain.common.v1.CheetahPoint.prototype.getX = function() {
  return /** @type{?proto.nockchain.common.v1.SixBelt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.SixBelt, 1));
};


/**
 * @param {?proto.nockchain.common.v1.SixBelt|undefined} value
 * @return {!proto.nockchain.common.v1.CheetahPoint} returns this
*/
proto.nockchain.common.v1.CheetahPoint.prototype.setX = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.CheetahPoint} returns this
 */
proto.nockchain.common.v1.CheetahPoint.prototype.clearX = function() {
  return this.setX(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.CheetahPoint.prototype.hasX = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SixBelt y = 2;
 * @return {?proto.nockchain.common.v1.SixBelt}
 */
proto.nockchain.common.v1.CheetahPoint.prototype.getY = function() {
  return /** @type{?proto.nockchain.common.v1.SixBelt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.SixBelt, 2));
};


/**
 * @param {?proto.nockchain.common.v1.SixBelt|undefined} value
 * @return {!proto.nockchain.common.v1.CheetahPoint} returns this
*/
proto.nockchain.common.v1.CheetahPoint.prototype.setY = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.CheetahPoint} returns this
 */
proto.nockchain.common.v1.CheetahPoint.prototype.clearY = function() {
  return this.setY(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.CheetahPoint.prototype.hasY = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool inf = 3;
 * @return {boolean}
 */
proto.nockchain.common.v1.CheetahPoint.prototype.getInf = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.nockchain.common.v1.CheetahPoint} returns this
 */
proto.nockchain.common.v1.CheetahPoint.prototype.setInf = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.SixBelt.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.SixBelt.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.SixBelt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.SixBelt.toObject = function(includeInstance, msg) {
  var f, obj = {
belt1: (f = msg.getBelt1()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt2: (f = msg.getBelt2()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt3: (f = msg.getBelt3()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt4: (f = msg.getBelt4()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt5: (f = msg.getBelt5()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f),
belt6: (f = msg.getBelt6()) && proto.nockchain.common.v1.Belt.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.SixBelt}
 */
proto.nockchain.common.v1.SixBelt.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.SixBelt;
  return proto.nockchain.common.v1.SixBelt.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.SixBelt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.SixBelt}
 */
proto.nockchain.common.v1.SixBelt.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt1(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt2(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt3(value);
      break;
    case 4:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt4(value);
      break;
    case 5:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt5(value);
      break;
    case 6:
      var value = new proto.nockchain.common.v1.Belt;
      reader.readMessage(value,proto.nockchain.common.v1.Belt.deserializeBinaryFromReader);
      msg.setBelt6(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.SixBelt.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.SixBelt.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.SixBelt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.SixBelt.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBelt1();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt2();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt3();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt4();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt5();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
  f = message.getBelt6();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.nockchain.common.v1.Belt.serializeBinaryToWriter
    );
  }
};


/**
 * optional Belt belt_1 = 1;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.SixBelt.prototype.getBelt1 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
*/
proto.nockchain.common.v1.SixBelt.prototype.setBelt1 = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
 */
proto.nockchain.common.v1.SixBelt.prototype.clearBelt1 = function() {
  return this.setBelt1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SixBelt.prototype.hasBelt1 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Belt belt_2 = 2;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.SixBelt.prototype.getBelt2 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
*/
proto.nockchain.common.v1.SixBelt.prototype.setBelt2 = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
 */
proto.nockchain.common.v1.SixBelt.prototype.clearBelt2 = function() {
  return this.setBelt2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SixBelt.prototype.hasBelt2 = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Belt belt_3 = 3;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.SixBelt.prototype.getBelt3 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
*/
proto.nockchain.common.v1.SixBelt.prototype.setBelt3 = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
 */
proto.nockchain.common.v1.SixBelt.prototype.clearBelt3 = function() {
  return this.setBelt3(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SixBelt.prototype.hasBelt3 = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Belt belt_4 = 4;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.SixBelt.prototype.getBelt4 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 4));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
*/
proto.nockchain.common.v1.SixBelt.prototype.setBelt4 = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
 */
proto.nockchain.common.v1.SixBelt.prototype.clearBelt4 = function() {
  return this.setBelt4(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SixBelt.prototype.hasBelt4 = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Belt belt_5 = 5;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.SixBelt.prototype.getBelt5 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 5));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
*/
proto.nockchain.common.v1.SixBelt.prototype.setBelt5 = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
 */
proto.nockchain.common.v1.SixBelt.prototype.clearBelt5 = function() {
  return this.setBelt5(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SixBelt.prototype.hasBelt5 = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Belt belt_6 = 6;
 * @return {?proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.SixBelt.prototype.getBelt6 = function() {
  return /** @type{?proto.nockchain.common.v1.Belt} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Belt, 6));
};


/**
 * @param {?proto.nockchain.common.v1.Belt|undefined} value
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
*/
proto.nockchain.common.v1.SixBelt.prototype.setBelt6 = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SixBelt} returns this
 */
proto.nockchain.common.v1.SixBelt.prototype.clearBelt6 = function() {
  return this.setBelt6(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SixBelt.prototype.hasBelt6 = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Belt.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Belt.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Belt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Belt.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.Belt.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Belt;
  return proto.nockchain.common.v1.Belt.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Belt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Belt}
 */
proto.nockchain.common.v1.Belt.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Belt.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Belt.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Belt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Belt.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 value = 1;
 * @return {number}
 */
proto.nockchain.common.v1.Belt.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v1.Belt} returns this
 */
proto.nockchain.common.v1.Belt.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.nockchain.common.v1.ErrorCode = {
  ERROR_CODE_UNSPECIFIED: 0,
  ERROR_CODE_INVALID_REQUEST: 1,
  ERROR_CODE_PEEK_FAILED: 2,
  ERROR_CODE_PEEK_RETURNED_NO_DATA: 3,
  ERROR_CODE_POKE_FAILED: 4,
  ERROR_CODE_NACKAPP_ERROR: 5,
  ERROR_CODE_TIMEOUT: 6,
  ERROR_CODE_INTERNAL_ERROR: 7,
  ERROR_CODE_NOT_FOUND: 8,
  ERROR_CODE_PERMISSION_DENIED: 9,
  ERROR_CODE_INVALID_WIRE: 10,
  ERROR_CODE_KERNEL_ERROR: 11
};

goog.object.extend(exports, proto.nockchain.common.v1);
